module.exports = __webpack_public_path__ + "static/media/dayana.b88e8166.png";